import { useState } from "react";
import { showError } from "../../utils/dialog";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";

const ResetPasswordForm = ({ onClose, onSave }) => {
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;

    if (!currentPassword.trim()) {
      showError("Current password is required");
      return;
    }
    if (!newPassword || newPassword.length < 8) {
      showError("New password must be at least 8 characters");
      return;
    }
    if (currentPassword === newPassword) {
      showError("New password must be different from your current password");
      return;
    }

    setSaving(true);
    try {
      await onSave?.({ currentPassword, newPassword });
    } catch {
      // Parent shows the error message.
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 relative">
        <button
          type="button"
          onClick={onClose}
          disabled={saving}
          className="absolute top-3 right-3 text-[#DC1F00] hover:bg-[#DC1F0033] p-3 rounded-full"
        >
          ✖
        </button>

        <div className="flex">
          <FaLock className="text-buttonRed text-lg w-5 h-5 mt-1 mr-2" />
          <h2 className="text-xl text-formTitleText font-semibold mb-4">Reset Password</h2>
        </div>

        <div className="h-[1px] bg-[#DC1F004D]"></div>

        <form className="flex-1 overflow-y-auto p-6" onSubmit={handleSubmit}>
          <h3 className="font-semibold text-[#000000] mb-4">Add Details :</h3>

          <div className="relative mb-2">
            <label className="block text-sm text-textGray mb-2">
              Current Password <span className="text-[#00000080]">*</span>
            </label>
            <input
              type={showCurrent ? "text" : "password"}
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              required
              disabled={saving}
              className="w-full border rounded-lg px-3 py-2 mb-1 focus:ring-1 focus:ring-red-400 disabled:opacity-50"
            />
            <div
              className="absolute right-4 top-10 cursor-pointer text-textGray"
              onClick={() => setShowCurrent((prev) => !prev)}
            >
              {showCurrent ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          <div className="relative mb-10">
            <label className="block text-sm text-textGray mb-2">
              Create New Password<span className="text-[#00000080]">*</span>
            </label>
            <input
              type={showNew ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
              disabled={saving}
              className="w-full border rounded-lg px-3 py-2 focus:ring-1 focus:ring-red-400 disabled:opacity-50"
            />
            <div
              className="absolute right-4 top-10 cursor-pointer text-[#00000080]"
              onClick={() => setShowNew((prev) => !prev)}
            >
              {showNew ? <FaEyeSlash /> : <FaEye />}
            </div>
            <span className="text-xs text-textGray">Make sure it’s 8 character or more</span>
          </div>

          <div className="flex items-center justify-between gap-4 mb-2">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="w-full border-2 border-buttonWhite hover:bg-buttonWhite-hover text-[#DC1F00] font-semibold px-4 py-2 rounded-full disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={saving}
              className="w-full bg-buttonRed hover:bg-buttonRed-hover text-white font-semibold px-4 py-2 rounded-full disabled:opacity-50"
            >
              {saving ? "Saving..." : "Change Password"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
